import httpClient from "../../api/httpClient";
import UnidadeArmazenamento from "../classes/UnidadeArmazenamento";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "DadosBasico/Sku/All" },
  { method: "GET", rota: "DadosBasico/Sku/" },
  { method: "POST", rota: "DadosBasico/Sku/Adicionar" },
  { method: "PUT", rota: "DadosBasico/Sku/Atualizar" },
  { method: "DELETE", rota: "DadosBasico/Sku/Apagar" },  
  { method: "GET", rota: "DadosBasico/MateriasPrimas/All/" },
  { method: "GET", rota: "DadosBasico/Sku/Count"},
];

const cacheKey: string = "UnidadeArmazenamentoCache";
const cacheKeySelC: string = "SKUSelecionado";

const apiServico: String = "PORTAL"

class UnidadeArmazenamentoDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }
  Adicionar(value: UnidadeArmazenamento) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[2].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Atualizar(value: UnidadeArmazenamento) {
    let ok: boolean = false;
    let error: any = undefined;
    super.put(calls[3].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Apagar(value: UnidadeArmazenamento) {
    let ok: boolean = false;
    let error: any = undefined;
    super.delete(calls[4].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  async ListarAtivos(): Promise<UnidadeArmazenamento[]> {
    return await super.Get(calls[0].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }  
  
  async ListarQuantidadeDeSkus(): Promise<number> {
    return await super.Get(calls[6].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarAtivoId(idSku: string): Promise<UnidadeArmazenamento[]> {
    return await super.Get(calls[1].rota + idSku)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarAtivosPorContrato(codigoFornecedorSap: Number, numeroContrato: String): Promise<UnidadeArmazenamento[]> {
    return await super.Get(calls[0].rota + '/' + codigoFornecedorSap + '/' + numeroContrato)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarMateriasPrimas(): Promise<UnidadeArmazenamento[]> {
    return await super.Get(calls[5].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): UnidadeArmazenamento[] {
    let result: UnidadeArmazenamento[] = JSON.parse(String(localStorage.getItem(cacheKey)));
    return result;
  }

  AdicionarListaAoCache(value: UnidadeArmazenamento[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

}
export default UnidadeArmazenamentoDataset;

